<template>
	<div class="ma-0 pa-0 full-width full-stretch" :class="{ 'pa-0' : isSmallScreen}">
		<v-layout wrap row class="full-width mb-4 mt-2">
			<v-layout xs12 md4 class="text-right allCenteredChild">
				<v-btn
					@click="addAcknowledgement"
					class="white--text"
					:color="themeInputColor"
				>Add Acknowledgement</v-btn>
			</v-layout>
		</v-layout>
		<v-data-table
			:headers="headers"
			:items="financeAcknowledgements.list"
			:items-per-page="5"
			class="elevation-1"
		>
			<template v-slot:items="props">
				<tr @click="showActionDetails(props.item)">
					<td class="text-xs-center">{{ props.item.userId }}</td>
					<td class="text-xs-center">{{ props.item.status }}</td>
					<td class="text-xs-center">{{ props.item.transferDate }}</td>
					<td class="text-xs-center">{{ props.item.transactionId }}</td>
					<td class="text-xs-center">{{ props.item.amount }}</td>
				</tr>
			</template>
		</v-data-table>
		<v-layout row wrap class="justify-center my-3 px-2 pb-2">
			<div>
				<v-btn
					:color="themeInputColor"
					class="white--text"
					v-if="financeAcknowledgements.offset"
					@click="fetchFinanceAcknowledgements({type: END})"
				>Load More</v-btn>
			</div>
		</v-layout>
		<add-acknowledgement
			@CLOSE_MODAL="closeModal"
			model="addAcknowledgementDialog"
			v-if="addAcknowledgementDialog"
			:themeInputColor="themeInputColor"
		></add-acknowledgement>
		<action-details
			@CLOSE_MODAL="closeModal"
			model="actionDetailsDialog"
			v-if="actionDetailsDialog"
			:themeInputColor="themeInputColor"
			:actionDetails="selectedAction"
		></action-details>
	</div>
</template>
<script>
import { mapState } from "vuex";
import { TOP, END } from "@/store/config";
import { FETCH_FINANCE_ACKNOWLEDGEMENTS } from "@/store/action-types";
import { themeInputColor } from "@/utils";
import addAcknowledgement from "./add-acknowledgement";
import ActionDetails from "./action-details";
export default {
	data() {
		return {
			themeInputColor,
			headers: [
				{
					text: "Distributor Id",
					value: "distributorId",
					align: "center",
					sortable: false
				},
				{
					text: "Action",
					value: "action",
					align: "center",
					sortable: false
				},
				{
					text: "Transfer Date",
					value: "takenOn",
					align: "center",
					sortable: false
				},
				{
					text: "Txn ID",
					value: "transferDate",
					align: "center",
					sortable: false
				},
				{
					text: "Amount",
					value: "amount",
					align: "center",
					sortable: false
				}
			],
			fetchingAcknowledgements: false,
			addAcknowledgementDialog: false,
			actionDetailsDialog: false,
			selectedAction: undefined,
			END
		};
	},
	mounted() {
		this.fetchFinanceAcknowledgements({ type: TOP });
	},
	components: {
		"add-acknowledgement": addAcknowledgement,
		"action-details": ActionDetails
	},
	computed: {
		...mapState({
			financeAcknowledgements: state =>
				state.finance.financeAcknowledgements
		}),
		isSmallScreen() {
			return this.$vuetify.breakpoint.name === "xs";
		}
	},
	methods: {
		fetchFinanceAcknowledgements(payload) {
			if (!this.fetchingAcknowledgements) {
				this.fetchingAcknowledgements = true;
				this.$store
					.dispatch(FETCH_FINANCE_ACKNOWLEDGEMENTS.dispatch, payload)
					.catch(() => {})
					.then(() => {
						this.fetchingAcknowledgements = false;
					});
			}
		},
		addAcknowledgement() {
			this.addAcknowledgementDialog = true;
		},
		showActionDetails(data) {
			this.selectedAction = data;
			this.actionDetailsDialog = true;
		},
		closeModal(payload) {
			this[payload] = false;
			this.selectedAction = undefined;
		}
	}
};
</script>
<style scoped>
</style>
